import React           from 'react'
import { Spin, Button} from 'antd'
import { Droppable }   from 'react-beautiful-dnd'
import FileItem        from './file-item'
import EmptyState      from '../../Shared/EmptyState'
import {isWindows}     from '../../../utils'

import './styles.scss'

export default ({files, any_cloud_accounts, files_loading, selection_count, dragging_id,
                  accounts_loading, on_select, on_play_video, has_more, droppable_id, is_drop_disabled, is_drag_disabled,
                  on_download, on_delete, on_share, on_open_encode, on_open_hybrik, on_show_media_info,
                  on_expand_options, on_refresh, on_navigate, on_load_more, on_move,
                  is_agent_running, on_launch_agent
                }) =>
  (
    <Droppable droppableId={droppable_id} isDropDisabled={is_drop_disabled}>
      {(provided, snapshot) =>
        (
          <div className={'files'}
               ref={provided.innerRef}
               style={{backgroundColor: snapshot.isDraggingOver ? 'gainsboro' : ''}}
               {...provided.droppableProps}>{
            (files_loading && (!files || files.length === 0)) ?
              <Spin size='small' tip='Loading...' style={{padding: '15% 50%', margin: '0 auto'}}/> :
              ((!files_loading && (!files || files.length === 0)) ?
                  <EmptyState title={is_agent_running ? 'No content found' : 'ftX client is not running'}
                              click_text={is_agent_running ? 'Refresh' : (isWindows() ? 'Launch ftX client':'ftX is only supported on windows')}
                              on_click={() => is_agent_running ? on_refresh() : on_launch_agent()}
                              content={
                                  isWindows() && <Button className={'ftx-dll'} onClick={e=>{
                                      e.stopPropagation()
                                      window.location='http://ftx.CloudFlyer.com/download/current/CloudFlyerDesktopFtxSetup.msi'
                                  }}>
                                      <span>{'Download ftX client'}</span>
                                  </Button>
                              }/> : [
                    <span className={'hint'} key={'hint'}>Select a file to see available actions</span>, (
                      files.map((file, index) =>
                        <FileItem key={index}
                                  index={index}
                                  file={file}
                                  droppable_id={droppable_id}
                                  selection_count={selection_count}
                                  is_ghosting={file.checked && dragging_id && dragging_id !== (file.basename || file.key)}
                                  is_drag_disabled={is_drag_disabled}
                                  on_play_video={on_play_video}
                                  on_select={on_select}
                                  on_download={on_download}
                                  on_delete={on_delete}
                                  on_share={on_share}
                                  on_open_encode={on_open_encode}
                                  on_show_media_info={on_show_media_info}
                                  on_open_hybrik={on_open_hybrik}
                                  on_expand_options={on_expand_options}
                                  on_navigate={on_navigate}
                                  on_move={on_move}
                        />)
                    )
                  ]
              )
          }
            {provided.placeholder}
          </div>
        )}
    </Droppable>
  )